import { observable } from 'mobx'
import * as moment from 'moment'

export default class userSleepPrefStore {
  @observable data = []
  @observable created = false
  @observable datasetId = ''
  @observable
  goal = {
    id: 0,
    goalStartDate: moment()
      .subtract(8, 'weeks')
      .format('l'),
    timeCompleteTo: '04:45',
    timeStartTo: '21:45',
    timeCompleteFrom: '06:45',
    timeStartFrom: '23:15',
    hrsDurationTo: 7,
    type: 'goal',
    sleepScore: '',
    indicatorColor: 'lightblue',
    brainClearness: '',
    mood: 0,
    description: '',
    incrementalChangeMins: 0
  }

  updateData(d) {
    this.data = d
  }

  updateGoal() {
    //todo
    if (this.data.length !== 0) {
      this.goal = this.data.goal.value
    }
  }

  updateCreated() {
    this.created = true
  }
}



// WEBPACK FOOTER //
// ./src/stores/userSleepPrefStore.js